import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
} from "@material-ui/core";
import { AuthorForm, CustomerForm } from "./components";
import { Link, useParams } from "react-router-dom";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    marginBottom: "0px",
    backgroundColor: "black", // Change background to black
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    padding: "10px 0",
    marginTop: "120px",
    marginBottom: "30px",
    [theme.breakpoints.down("md")]: {
      marginTop: "120px",
      marginBottom: "30px",
    },
    maxWidth: "600px",
    width: "90%",
    margin: "0 auto",
  },
  heading: {
    width: "90%",
    margin: "10px auto",
    color: "gold", // Change text color to gold
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    width: "200px",
    margin: "10px",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  text: {
    color: "gold", // Change text color to gold
  },
}));

function SignUp() {
  const classes = useStyles();
  const params = useParams();
  return (
    <Fragment>
      <Helmet>
        <title>Register - d2p</title>
      </Helmet>
      <ToastContainer />
      <div className={classes.root}>
        <Container>
          <Paper className={classes.paper}>
            {params.role === "customer" ? <CustomerForm /> : <AuthorForm />}
            <hr style={{ width: "80%", margin: "0 auto" }} />
            <Box align="center">
              <Link to="/login" style={{ textDecoration: "none", color: "inherit" }}>
                <h3 className={classes.text} style={{ fontWeight: "500", fontSize: "18px" }}>
                  Already Have an Account?
                </h3>
              </Link>
              <Link style={{ textDecoration: "none" }} to="/login">
                <Button className={classes.btn}>Log In Here</Button>
              </Link>
            </Box>
          </Paper>
        </Container>
      </div>
    </Fragment>
  );
}

export default SignUp;
